<template>
  <section class="vbox">
    <section class="scrollable padder">
      <section class="row m-b-md brud-theme">
        <div class="col-sm-6 text-black">
          <ol class="breadcrumb text-left">
            <li>
              <a href="#"><i class="fa fa-dashboard"></i> Home</a>
            </li>
            <li class="active">List of Sites</li>
          </ol>
        </div>
        <div class="col-sm-6 text-right text-left m-t-sm">
          <small> </small>
        </div>
      </section>

      <section class="panel panel-default">
        <header class="panel-heading">
          <div class="row">
            <div class="col-sm-12">
              <a
                v-on:click="showForm()"
                class="btn btn-success pull-right"
              >
                <i class="fa fa-plus"> </i> New Site
              </a> 
              <h4>
                <i class="fa fa-list-ul"></i>
                Search Site/Location
              </h4>
            </div>
          </div>
        </header>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-10">
              <b-form-input
                id="filter-input"
                v-model="filter"
                type="search"
                placeholder="Type to Search"
              ></b-form-input>
            </div>
            <div class="col-md-2">
              <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
            </div>
          </div>
          <hr/>
          
            <div class="co-md-12">
                <div class="section">
                    <b-table id="item-table"
                      :fields="fields"
                      :filter-included-fields="filterOn"
                      @filtered="onFiltered"
                      :filter="filter"
                      hover
                      :items="itemList" 
                      :per-page="perPage"
                      :current-page="currentPage">
                      <!-- A virtual column -->
                      <template #cell(sno)="data">
                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                      </template>
                      <template #cell(action)="data">
                        <a
                          v-on:click="showForm(data.item.site_id)"
                          class="btn label-warning btn-xs"
                          style="float: left;display: block; width: 100%;"
                          ><i class="fa fa-edit"></i> Edit</a
                        >
                      </template>
                    </b-table>
                  <!-- Show pagination links -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="totalRows"
                      :per-page="perPage"
                      aria-controls="item-table"
                      hide-ellipsis
                      ></b-pagination>
                </div>
            </div>
        </div>
      </section>
      <panel-modal
        v-if="showFormModal"
        class-list="col-md-6"
        @close="showFormModal = false"
      >
        <template #header>
          <h4>
            <i class="fa fa-list-ul"></i>
            Add / Edit Site
          </h4>
        </template>
        <template #body>
          <AddSite
            :siteId="itemId"
            v-on:list-items="getList()"
            v-on:hide-form="showFormModal = false"
          />
        </template>
      </panel-modal>
    </section>
  </section>
</template>

<script>

import api from "../api";
import AddSite from "../components/AddSite.vue";
import PanelModal from "../components/PanelModal.vue";
import { BTable, BPagination, BFormInput, BButton } from 'bootstrap-vue'

export default {
  name: "Site",

  components: {
    AddSite,
    PanelModal,
    BPagination,
    BTable,
    BFormInput,
    BButton
  },
  data() {
    return {
      showFormModal: false,
      itemList: [],
      itemId: "",
      filter: null,
      filterOn: ['site_name', 'project_name'],
      perPage: 10,
      currentPage: 1,
      totalRows: 1,
      fields: [
        { key:'sno', label: '#'},
        { key:'site_name', label: 'Site Name'},
        { key:'project_name', label: 'Project Name'},
        { key:'site_address', label: 'Site Location'},
        { key:'site_mobile', label: 'Mobile'},
        { key:'action', label: 'Action'},
        ]
    };
  },
  methods: {
    getList: function() {
      const list = {
        filter: {
        },
      };
      api
        .request("post", "GeneralApis/get_sites", list)
        .then((response) => {
          var data = response.data;
          console.log(data);
          if (data.errorcode) {
            if (data.errorcode === 25000) {
              this.$router.push('/login')
            }
            this.itemList = response.data.values;
          } else {
            this.itemList = data.siteList;
            this.totalRows = this.itemList.length
          }
        });
    },
    showForm: function(siteid) {
      this.itemId = siteid;
      this.showFormModal = true;
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    }
  },
  mounted(){
    this.getList()
  }
};
</script>
